import { reconnect } from '../actions/reconnect';
import type { Config } from '../createConfig';

type HydrateParameters = {
  reconnectOnMount?: boolean | undefined;
};

export function hydrate(config: Config, parameters: HydrateParameters) {
  const { reconnectOnMount } = parameters;

  return {
    async onMount() {
      if (reconnectOnMount) {
        console.log('reconnect on mount, config.uid = ', config.uid);
        reconnect(config);
      } else if (config.storage) {
        // Reset connections that may have been hydrated from storage.
        config.setState((x) => ({
          ...x,
          connections: new Map(),
        }));
      }
    },
  };
}
